import {
	INITIAL_HELP_REQUEST,
	FINAL_HELP_REQUEST,
	FETCH_HELP_CENTER_SUCCESS,
	SAVE_HELP_CENTER_SUCCESS,
	DELETE_HELP_CENTER_SUCCESS,
	ERROR,
} from "../types/help_center.types";

const initialState = {
	questions: [],
	loading: false,
	error: null,
	total: 0,
	last_page: 0,
	from: 0,
	to: 0,
	current_page: 0,
};
function updates(state = initialState, action) {
	switch (action.type) {
		case INITIAL_HELP_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case FINAL_HELP_REQUEST:
			return {
				...state,
				loading: false,
			};
		case FETCH_HELP_CENTER_SUCCESS:
			return {
				...state,
				loading: false,
				questions: action.payload.questions,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				current_page: action.payload.current_page,
			};
		case SAVE_HELP_CENTER_SUCCESS:
			return {
				...state,
				loading: false,
				questions: action.payload.questions,
			};
		case DELETE_HELP_CENTER_SUCCESS:
			return {
				...state,
				loading: false,
				questions: action.payload.questions,
			};
		case ERROR:
			return {
				...state,
				loading: false,
				error: action.paylaod.error,
				updates: [],
			};
		default:
			return state;
	}
}

export default updates;
